'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

function FloatingSocialButtons() {
  const pathname = usePathname();
  const isAgentProfile = pathname?.startsWith('/agent-profile/');
  const isDashboard = pathname?.startsWith('/dashboard');

  if (isAgentProfile || isDashboard) {
    return null;
  }

  const buttons = [
    {
      key: 'instagram',
      label: 'Instagram',
      href: 'https://instagram.com/surilipathub',
      bgClass: 'bg-gradient-to-br from-[#405DE6] via-[#C13584] to-[#FFDC80]',
      icon: 'CameraIcon',
      textColor: 'text-white',
    },
    {
      key: 'tiktok',
      label: 'TikTok',
      href: 'https://tiktok.com/@surilipathub',
      bgClass: 'bg-black',
      icon: 'MusicalNoteIcon',
      textColor: 'text-white',
    },
    {
      key: 'threads',
      label: 'Threads',
      href: 'https://www.threads.net/@surilipathub',
      bgClass: 'bg-black',
      icon: 'AtSymbolIcon',
      textColor: 'text-white',
    },
  ] as const;

  return (
    <div className="fixed bottom-6 left-6 z-50 flex flex-col gap-3">
      {buttons.map((btn) => (
        <a
          key={btn.key}
          href={btn.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={btn.key === 'whatsapp' ? 'WhatsApp' : btn.label}
          title={btn.key === 'whatsapp' ? 'Let us help you!' : btn.label}
          className={`group/btn relative w-12 h-12 rounded-full flex items-center justify-center shadow-brand hover:shadow-brand-lg transition-transform duration-200 hover:scale-105 border border-white/10 ${btn.bgClass}`}
        >
          <Icon name={btn.icon} size={22} variant="outline" className={`${btn.textColor}`} />
          <span className="pointer-events-none absolute left-14 top-1/2 -translate-y-1/2 bg-secondary text-secondary-foreground px-3 py-1 rounded-full text-xs font-semibold shadow-soft opacity-0 scale-95 group-hover/btn:opacity-100 group-hover/btn:scale-100 transition-all whitespace-nowrap">
            {btn.label}
          </span>
        </a>
      ))}
    </div>
  );
}

export default FloatingSocialButtons;
